import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomFieldsMixin from "@Shared/utils/board-mixins/custom-fields-mixin";
import TooltipsMixin from "@Shared/utils/shared-mixins/tooltips-mixin";
import { mapGetters } from "vuex";
import { CUSTOM_FIELD_DROPDOWN_VALUE } from "@Broker/@Modules/clients/board/store/board-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ProfileCardCustomFields",
  filters: {
    formatFieldValue(field) {
      if (field.type === "address") return field.value["formatted-address"];
      return field.value;
    }
  },
  mixins: [CustomFieldsMixin, TooltipsMixin],
  props: {
    boardId: {
      type: [String, Number],
      required: true
    },
    customFields: {
      type: Array,
      required: true
    },
    customFieldsDefinitions: {
      type: Object,
      required: true
    },
    isDisplayedInSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      MAX_NAME_LENGTH: this.isDisplayedInSearch ? 200 : 14
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("BoardStore", [CUSTOM_FIELD_DROPDOWN_VALUE])), {}, {
    visibleCustomFields() {
      var _context;
      return _filterInstanceProperty(_context = this.customFields).call(_context, ({
        id,
        value
      }) => {
        var _this$customFieldsDef;
        const definition = (_this$customFieldsDef = this.customFieldsDefinitions.byId) == null ? void 0 : _this$customFieldsDef[id];
        return value && definition && definition.visibility !== "none";
      });
    }
  }),
  destroyed() {
    this.destroyTooltips();
  },
  mounted() {
    this.initTooltips();
  },
  methods: {
    getVisibility(customFieldId) {
      return this.customFieldsDefinitions.byId[customFieldId].visibility;
    },
    getIconStyles(field) {
      return this.typeDefinitions[field.type].icon;
    },
    getDropdownValue(field) {
      return this.CUSTOM_FIELD_DROPDOWN_VALUE(this.boardId, field.id, field.value);
    },
    formatDateLocalCustom(date) {
      return this.$options.filters.formatDateLocalCustom(date, "MMM D, YYYY");
    },
    formatFieldValue(value) {
      return this.$options.filters.formatFieldValue(value);
    },
    getValueTooltipOptions(field) {
      let title;
      switch (field.type) {
        case "date":
          title = this.formatDateLocalCustom(field.value);
          break;
        case "dropdown":
          title = this.getDropdownValue(field);
          break;
        default:
          title = this.formatFieldValue(field);
          break;
      }
      return {
        title,
        placement: "right",
        boundary: "viewport"
      };
    },
    customFieldName(fieldName) {
      switch (fieldName) {
        case "Upcoming Date":
          return this.$t("global.doorr.upcomingDate");
        case "Closing Date":
          return this.$t("global.doorr.closingDate");
        case "Renewal Date":
          return this.$t("global.doorr.renewalDate");
        case "Label":
          return this.$t("global.words.label");
        default:
          return fieldName;
      }
    }
  }
});